let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gNH7X")).then(() => parcelRequire('bhsA0'));